import styled from 'styled-components';

export const Section = styled.div`
  font-size: 12px;
  border-radius: 3px;
  /* background: rgba(0, 0, 0, 0.05); */
`;
